import { Grid } from '@material-ui/core'
import React from 'react'
import { FakeFieldTemplateScheme } from '../FakeFieldTemplate/FakeFieldTemplateScheme'

export const FakeFieldScheme = ({
    fakeFields
}) => {
  return (
       <Grid container spacing={1}>
            {fakeFields.map((fieldProps) =>
                <FakeFieldTemplateScheme 
                        {...fieldProps}
                        key={`field-template-scheme${fieldProps.variable}`}
                />
            )}
        </Grid>  
  )
}
